const permissions = () => [
  {
    ordem: 0,
    name: 'Dashboard',
    path: '/app/dashboard',
    typeUser: 'corretora'
  },
  {
    ordem: 1,
    name: 'Assinaturas',
    path: '/app/signature',
    typeUser: 'client'
  },
  {
    ordem: 2,
    name: 'Usuários',
    path: '/app/users',
    typeUser: 'corretora'
  },
  {
    ordem: 3,
    name: 'Permissões padrões',
    path: '/app/permissions',
    typeUser: 'operadora'
  },
  {
    ordem: 4,
    name: 'Minha conta',
    path: '/app/myAccount',
    typeUser: 'corretora'
  },
  {
    ordem: 5,
    name: 'Propostas',
    path: '/app/clients',
    typeUser: 'corretora'
  },
  {
    ordem: 6,
    name: 'Cotações',
    path: '/app/simulations',
    typeUser: 'corretora'
  },
  {
    ordem: 7,
    name: 'Cotação',
    path: '/app/quotation',
    typeUser: 'operadora'
  },

  {
    ordem: 8,
    name: 'Operadoras',
    path: '/app/operators',
    typeUser: 'administradora'
  },
  {
    ordem: 9,
    name: 'Corretoras',
    path: '/app/brokers',
    typeUser: 'operadora'
  },
  {
    ordem: 10,
    name: 'Associações',
    path: '/app/associations',
    typeUser: 'operadora'
  },
  {
    ordem: 11,
    name: 'Avisos',
    path: '/app/warnings',
    typeUser: 'operadora'
  },
  {
    ordem: 12,
    name: 'Formulários',
    path: '/app/forms',
    typeUser: 'operadora'
  },
  {
    ordem: 13,
    name: 'Declaração de saúde',
    path: '/app/declarationHealth',
    typeUser: 'operadora'
  },
  {
    ordem: 14,
    name: 'Cadastro de vigências',
    path: '/app/terms',
    typeUser: 'operadora'
  },
  {
    ordem: 15,
    name: 'Cadastro de restrições',
    path: '/app/restrictions',
    typeUser: 'operadora'
  },
  {
    ordem: 16,
    name: 'Produtos',
    path: '/app/products',
    typeUser: 'operadora'
  },
  {
    ordem: 17,
    name: 'Tabelas',
    path: '/app/tables',
    typeUser: 'operadora'
  },
  {
    ordem: 18,
    name: 'Reajustes',
    path: '/app/readjustments',
    typeUser: 'operadora'
  },
  {
    ordem: 19,
    name: 'Carências',
    path: '/app/shortages',
    typeUser: 'operadora'
  },
  {
    ordem: 20,
    name: 'Relatório de vendas',
    path: '/app/reports/repSales',
    typeUser: 'corretora'
  },
  {
    ordem: 21,
    name: 'Relatório de simulações',
    path: '/app/reports/repSimulations',
    typeUser: 'corretora'
  },
  {
    ordem: 22,
    name: 'Comissões',
    path: '/app/comissions',
    typeUser: 'corretora'
  },
  {
    ordem: 23,
    name: 'Configurações de email',
    path: '/app/email',
    typeUser: 'operadora'
  },
  {
    ordem: 24,
    name: 'Configurações do sistema',
    path: '/app/config',
    typeUser: 'operadora'
  },
  {
    ordem: 25,
    name: 'AI Chat',
    path: '/app/iaChat',
    typeUser: 'corretora'
  },
  {
    ordem: 26,
    name: 'Kanban',
    path: '/app/pipeline/kanban',
    typeUser: 'operadora'
  },
  {
    ordem: 27,
    name: 'Funil de vendas',
    path: '/app/pipeline/funnel',
    typeUser: 'operadora'
  },
  {
    ordem: 28,
    name: 'Kanban de leads',
    path: '/app/leads/kanban',
    typeUser: 'operadora'
  }
];

export default permissions;
